import { environment } from '@environments/environment';

export const GET_OTHER_FRONTS_QUERY = (langcode: string, notCategory: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_finitions,
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:taxonomy_term',
            },
          },
          {
            term: {
              vid: 'categorie_facade',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
        ],
        must_not: {
          terms: {
            name: [notCategory],
          },
        },
      },
    },
    _source: ['name', 'field_visuel', 'field_page_link', 'field_categorie_facade_prix'],
  },
});
